var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('Header'),_c('router-view',{attrs:{"status":_vm.isFooter},on:{"update:status":function($event){_vm.isFooter=$event}}}),(_vm.isFooter)?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }